export default __webpack_public_path__ + "8c660ba59d3958859ba0465d37a19b3d.png";